export default __webpack_public_path__ + "static/another-line-72e5cde09679e767550855d0f06d8680.svg";